import { env } from './env';

const getBackend = () => {
  return env.VITE_BACKEND_URL;
};

export default getBackend;
